import { render, staticRenderFns } from "./kegcontrol.vue?vue&type=template&id=415150ba&scoped=true"
import script from "./kegcontrol.vue?vue&type=script&lang=js"
export * from "./kegcontrol.vue?vue&type=script&lang=js"
import style0 from "./kegcontrol.vue?vue&type=style&index=0&id=415150ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415150ba",
  null
  
)

export default component.exports